import { Component, computed, input, output } from '@angular/core';
import { type StatCardColor } from './stat-card.model';

@Component({
  selector: 'lib-stat-card',
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/stat-card-tokens.css',
    './stat-card.component.css',
  ],
  templateUrl: './stat-card.component.html',
  host: {
    '[class]': 'hostClasses()',
    '(click)': 'clicked.emit()',
  },
})
export class StatCardComponent {
  readonly color = input<StatCardColor>('blue');
  readonly clicked = output<void>();

  readonly hostClasses = computed(() => ({
    [`msa-stat-card--${this.color()}`]: true,
  }));
}
